// i18n area 'common' — locale sq-AL (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.sq-AL.meta.json.
import type { enUS } from './common'

export const sqAL: typeof enUS = {
  nav: {
    home: 'Kreu',
    vms: 'Makinat virtuale',
    templates: 'Shabllonet',
    importVms: 'Importo VM',
    containers: 'Kontejnerët',
    containersApps: 'App',
    containersPods: 'Pod-e',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'Imazhet OCI',
    containersOciRegistries: 'Registry OCI',
    containersCtTemplates: 'Shabllonet CT',
    networkServices: 'Shërbimet e rrjetit',
    firewall: 'Firewall',
    checkpoints: 'Checkpoint-et',
    backup: 'Backup',
    monitoring: 'Monitorimi',
    cluster: 'Klasteri',
    clusterSettings: 'Cilësimet globale',
    clusterNodes: 'Nyjet',
    clusterDevices: 'Burimet USB dhe PCIe',
    clusterFederation: 'Federimi',
    network: 'Rrjeti',
    overlayNetworks: 'Rrjetet overlay',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Të dhënat',
    storages: 'Storage',
    hci: 'Hiperkonvergjenca',
    ceph: 'Ceph',
    system: 'Sistemi',
    tasks: 'Task-et',
    events: 'Ngjarje',
    audit: 'Auditim',
    diagnostics: 'Diagnostika',
    notifications: 'Njoftime',
    proximity: 'TVirt Proximity',
    users: 'Përdoruesit dhe grupet',
    groups: 'Grupet',
    mfa: 'MFA',
    realms: 'Realm-et dhe SSO',
    rbac: 'Rolet dhe lejet',
    credentials: 'Kredencialet',
    scopes: 'Scope-et',
    tags: 'Tag-et',
    explorer: 'Eksploro',
    licensing: 'Licenca',
    information: 'Informacione'
  },
  mode: {
    light: 'E çelët',
    dark: 'E errët',
    system: 'Sistemi',
    tooltip: 'Tema'
  },
  language: {
    tooltip: 'Gjuha'
  },
  langRegion: {
    europe: 'Evropa',
    northAmerica: 'Amerika e Veriut',
    southAmerica: 'Amerika e Jugut',
    asia: 'Azia'
  },
  notFound: {
    title: 'Faqja nuk u gjet',
    body: 'Kjo adresë nuk përkon me asnjë faqe të TVirt — mund të jetë zhvendosur me një përditësim, ose linku është i vjetër.',
    backHome: 'Kthehu te Kreu'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'I gjithë klasteri',
    noChildren: 'Asnjë nën-scope këtu',
    recursive: 'Përfshi pasardhësit',
    collapse: 'Palos panelin e scope-ve',
    openPicker: 'Eksploro scope-et',
    up: 'Ngjitu një nivel',
    countTooltip: '{direct} në këtë scope · {total} me pasardhësit'
  },
  search: {
    tooltip: 'Kërko (⌘K)',
    placeholder: 'Kërko VM, rrjete, storage…',
    empty: 'Asnjë rezultat',

    // Round command palette (#221, ratifica 2026-08-06): intestazioni dei
    // gruppi, i tipi fuori dal censimento explorer, il vocabolario tasti e i
    // verbi del gruppo Azioni.
    groups: {
      recent: 'Të fundit',
      shortcuts: 'Shkurtore',
      actions: 'Veprime',
      goTo: 'Shko te'
    },
    kind: {
      catalog: 'Katalogu',
      scope: 'Scope',
      node: 'Nyjë'
    },
    footer: {
      navigate: 'lundro',
      open: 'hap',
      close: 'mbyll'
    },
    actions: {
      createVm: 'Krijo VM…',
      uploadIso: 'Ngarko ISO…',
      clusterSettings: 'Cilësimet e klasterit',
      consoleOf: 'Shko te konsola e {name}'
    }
  },
  stub: {
    containersSummary: 'Aplikacione dhe kontejnerë sistemi (CT), me imazhet e tyre OCI, registry-t dhe shabllonet — të menaxhuar krah VM-ve të tua.',
    sectionSummary_vms: 'Makina virtuale dhe shabllonet e tyre — cikli i jetës, snapshot-et, migrimi dhe konsolat.',
    sectionSummary_storages: 'Storage-et ku jetojnë disqet, imazhet dhe metadatat e VM-ve.',
    sectionSummary_catalogs: 'Shtëpia e artefakteve skedarë të klasterit: imazhe ISO, shabllone CT dhe VM dhe arkiva OCI, të organizuar në katalogë.',
    sectionSummary_overlay: 'Rrjete overlay VXLAN mes nyjeve të klasterit.',
    sectionSummary_fabric: 'Inventari i rrjetit fizik — switch-et, portat, LAGG-et dhe rrjetet logjike.',
    sectionSummary_ipam: 'Adresimi i rrjedhur nga rrjetet fabric dhe overlay: kush e mban secilën adresë.',
    sectionSummary_services: 'Serverë DHCP dhe DNS të prodhuar nga regjistri i rrjetit.',
    sectionSummary_ceph: 'Klasterë Ceph të menaxhuar në nyjet TVirt.',
    sectionSummary_hci: 'Teknologjitë storage hiperkonvergjente në nyjet TVirt.',
    sectionSummary_cluster: 'Nyjet, anëtarësia dhe cilësimet në nivel klasteri.',
    containers: 'Kontejnerët e sistemit janë në roadmap — ky seksion do t’i presë.',
    containersApps: 'Aplikacionet e kontejnerizuara janë në roadmap — kjo zonë do t’i presë.',
    containersPods: 'Pod-et grupojnë kontejnerë që ndajnë rrjetin dhe volumet — instancat janë aplikacionet.',
    containersCt: 'Kontejnerët e sistemit (CT) janë në roadmap — kjo zonë do t’i presë.',
    multiscsi: 'TVStor MultiSCSI është në roadmap — kjo zonë do ta presë.',
    clusterFederation: 'Federimi mes klasterëve TVirt është në roadmap — kjo zonë do ta presë.',
    containersOciImages: 'Imazhet OCI janë në roadmap — kjo zonë do t’i presë.',
    containersOciRegistries: 'Registry-t OCI janë në roadmap — kjo zonë do t’i presë.',
    containersCtTemplates: 'Shabllonet CT janë në roadmap — kjo zonë do t’i presë.',
    importVms: 'Importer-ët ESXi dhe Proxmox do të vijnë këtu: konvertimi i guest-ëve dhe migrimi masiv brenda TVirt.',
    backup: 'Backup-i i integruar vjen me 6.2: repository content-addressed të deduplikuar, inkrementalë CBT, dritare pandryshueshmërie dhe replikim repo-to-repo.',
    monitoring: 'Dashboard-et e konkurrencës për burime në shkallë klasteri (cpu.ready, presioni PSI, alert-e të integruar) janë në ardhje — sot të njëjtat metrika jetojnë te detajet e secilës VM.'
  },
  home: {
    welcome: 'Je futur me llogarinë: {name}',
    subtitle: 'Ja klasteri yt TVirt me një vështrim.',
    loadError: 'Panorama nuk mund të ngarkohej — a është i arritshëm backend-i TVirt?',
    health: {
      ok: 'Gjithçka në rregull',
      warning: 'Kujdes',
      critical: 'Probleme kritike'
    },
    reason: {
      'node-down': '{subject} është i fikur',
      'node-stale': '{subject} nuk jep shenja prej pak kohësh',
      'node-maintenance': '{subject} në mirëmbajtje',
      'tasks-failed': {
        one: '{n} task i dështuar në 24 orët e fundit',
        other: '{n} task-e të dështuar në 24 orët e fundit'
      },
      'storage-degraded': 'storage {subject} i degraduar',
      'storage-error': 'storage {subject} në gabim',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'store-i i klasterit i paarritshëm',
      'license-absent': 'asnjë licencë — VM-të e reja nuk mund të nisen',
      'license-expired': 'licenca ka skaduar — VM-të e reja nuk mund të nisen',
      'license-exceeded': 'kufiri i licencës u tejkalua — VM-të e reja nuk mund të nisen',
      'failover-reserve-eroded': 'rezerva e failover-it gati e konsumuar',
      'failover-reserve-exhausted': 'rezerva e failover-it e shteruar — VM-të e reja nuk mund të nisen',

      'oci-cache-nearly-full': 'cache-i OCI gati plot në {subject} — digest-et dëbohen me dorë',
      'oci-cache-full': 'cache-i OCI plot në {subject} — asnjë pull nuk do të ketë sukses derisa të dëbosh digest-e',
      'config-replica-empty': 'replika e konfigurimit në {subject} është BOSH — nyja nuk ka konfigurim të cluster-it derisa një replikim të ketë sukses',
      'config-replica-stalled': 'replikimi i konfigurimit në {subject} ka ngecur — kopja lokale mbetet pas konfigurimit të cluster-it'
    },
    staleChip: 'Të dhëna të pafreskuara',
    staleAsOf: 'replika e fundit {time}',
    zone: {
      nodes: 'Nyjet',
      failoverReserve: 'Rezerva e failover-it',
      capacity: 'Kapaciteti',
      workload: 'Ngarkesa e punës',
      protection: 'Mbrojtja',
      activity: 'Aktiviteti i fundit'
    },

    // La zona riserva di failover (admission control N+1, task #133b).
    reserve: {
      state: {
        ok: 'Rezerva e paprekur',
        eroded: 'Rezerva gati e konsumuar',
        exhausted: 'Rezerva e shteruar',
        unknown: 'Rezerva e panjohur'
      },
      tolerate: {
        one: 'toleron humbjen e {n} nyjeje',
        other: 'toleron humbjen e {n} nyjeve'
      },
      usedOf: '{used} / {allowed} GiB në përdorim',
      keepFree: '{n} GiB të mbajtur të lirë për failover-in',
      expendable: 'nga të cilët {n} të sakrifikueshëm gjatë punës',
      headroom: 'mund të nisen ende {n} GiB',
      short: 'rezervës i mungojnë {n} GiB — VM-të e reja nuk mund të nisen',

      // Pagine enormi per taglia (ratifica 2026-08-04) — forma «etichetta:
      // {n}» apposta: nessuna lingua deve declinare dopo un numero variabile.
      hp: {
        usedOf: 'Faqe prej {size} — në përdorim: {used} / {allowed}',
        keepFree: 'të mbajtura të lira për failover-in: {keep}',
        headroom: 'ende të nisshme: {n}',
        short: 'mungojnë në rezervë: {n} — VM-të e reja me faqe të mëdha nuk mund të nisen'
      },
      worstCase: 'rasti më i keq: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Asnjë nyjë s’ka deklaruar ende memorien — rezerva nuk mund të llogaritet dhe asnjë nisje nuk refuzohet.',
      reason: {
        attestedDown: 'i atestuar i fikur',
        maintenance: 'në mirëmbajtje',
        unreachable: 'i paarritshëm',
        capacityUnknown: 'memorie e padeklaruar'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} core / {threads} thread',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} VM aktive',
        other: '{n} VM aktive'
      },
      activeVmsUnknown: 'VM aktive të panjohura',
      lastSeen: 'parë {time}',
      neverSeen: 'i paparë ndonjëherë',
      down: 'I fikur',
      maintenance: 'Mirëmbajtje',
      stale: 'I paarritshëm'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB të provizionuar',
      reserve: 'rezervë {n} GiB',
      unobserved: 'kapaciteti ende i pavëzhguar',
      empty: 'Ende asnjë storage'
    },
    workload: {
      vms: 'Makina virtuale',
      apps: 'App',
      services: 'Shërbimet e rrjetit',
      empty: 'Ende asgjë',
      phasesUnknown: 'ndarja sipas fazave e padisponueshme'
    },
    protection: {
      none: 'Asnjë destinacion backup-i i konfiguruar — mbro konfigurimin tënd.',
      configure: 'Konfiguro checkpoint-et',
      noRuns: 'Ende nuk është krijuar asnjë checkpoint.',
      last: 'Checkpoint-i i fundit',
      onTarget: 'në {target}',
      viewAll: 'Checkpoint-et'
    },
    activity: {
      empty: 'Asnjë aktivitet i fundit',
      failed24: {
        one: '{n} i dështuar në 24 orë',
        other: '{n} të dështuar në 24 orë'
      },
      viewAll: 'Shiko të gjithë task-et'
    }
  },
  notes: {
    title: 'Shënime',
    tabEdit: 'Modifiko',
    tabPreview: 'Parapamja',
    placeholder: 'Shënime të lira të operatorit — Markdown-i shfaqet i formatuar në parapamje',
    empty: 'Asnjë shënim',
    tooLarge: 'Shënimet e tejkalojnë kufirin prej 64 KiB',
    saveError: 'Shënimet nuk mund të ruheshin'
  },
  common: {

    // Round «errori onesti» (2026-08-03): una risposta 200 che questo client
    // non sa leggere NON è una rete giù — accusare il backend manda
    // l'operatore a guardare un servizio che funziona (bug hunt #157, U1).
    contractError: 'Përgjigjja e backend-it përmban një vlerë që kjo ndërfaqe nuk e njeh: {field}={value} — përditëso webui-n në versionin e backend-it.',
    contractErrorItems: '{count} objekte të kësaj liste nuk lexohen dot nga kjo ndërfaqe ({field}={value}) dhe nuk shfaqen.',
    staleHint: 'Store-i nuk arrihet — kjo është replika e konfigurimit të kësaj nyje; gjendja e flotës është e panjohur.',
    staleStateAge: 'gjendja më {time}',
    staleStateNever: 'gjendja nuk është marrë kurrë nga store-i: shihni vetëm vëzhgimet e kësaj nyje',
    staleStateTooltip: 'Store-i i cluster-it nuk arrihet: gjendja e vëzhguar (faza, nyja, agjenti) vjen nga replika e gjendjes së kësaj nyje dhe i përket leximit të fundit të suksesshëm nga store-i — mund të jetë e vjetruar.',
    noPermission: 'Nuk ke leje për këtë veprim',

    // Un budget di attesa scaduto NON è un esito (Luca 2026-08-06): il
    // cronometro del client misura la pazienza del client, non lo stato del
    // server — l'avviso dice «ancora in corso», mai «non riuscita».
    actionStillRunning: 'Veprimi është ende në proces: përfundimi nuk dihet ende',
    staleWrite: 'Dikush tjetër e ndryshoi këtë objekt ndërsa po e modifikonit — nuk u shkrua asgjë. Ringarkoni dhe përsëritni ndryshimin mbi gjendjen e freskët.',
    staleReload: 'Ringarko',
    preview: 'Parapamje',
    previewTitle: 'Parapamja e rezultatit',
    previewNothingWritten: 'Simuluar në server — nuk u shkrua asgjë.',
    previewChanged: 'Të theksuara: vlerat që do të ndryshonin.'
  },
  context: {
    copySelection: 'Kopjo tekstin e zgjedhur'
  },
  crud: {
    create: 'Krijo',
    viewDetails: 'Shiko detajet',
    viewOrEdit: 'Shiko ose modifiko',
    selected: 'të zgjedhur',
    viewUsingVms: 'Shiko VM-të që e përdorin burimin',
    clearSelection: 'Hiq zgjedhjen',
    deleteSelected: 'Fshi të zgjedhurit',
    bulkConfirmBody: {
      one: 'Të fshihet {count} element i zgjedhur? Nëse është i mbrojtur, do të raportohet dhe do të mbahet.',
      other: 'Të fshihen {count} elementet e zgjedhur? Të mbrojturit do të raportohen dhe do të mbahen.'
    },
    bulkDeleted: 'të fshirë',
    bulkRefused: 'të refuzuar',
    fieldId: 'ID',
    createdAt: 'Krijuar më',
    updatedAt: 'Përditësuar më',
    immutableField: 'I fiksuar në krijim — contract-i nuk e lejon ndryshimin e tij',
    immutableScope: 'Scope-i caktohet në krijim; disa burime zhvendosen me një veprim të dedikuar',
    observedField: 'Gjendje e vëzhguar — raportohet nga platforma, nuk modifikohet'
  }
}
